import type { SettingsRepository } from '@core/repositories/SettingsRepository';
import { httpClient } from '@infrastructure/http/httpClient';
import { toAppError } from '@infrastructure/http/errorMapper';

interface SettingsEnvelope {
  data: Record<string, unknown>;
}

export class SettingsRepositoryImpl implements SettingsRepository {
  async getAll(): Promise<Record<string, unknown>> {
    try {
      const response = await httpClient.get<SettingsEnvelope>('/settings');
      return response.data.data;
    } catch (error) {
      throw toAppError(error);
    }
  }

  async set(key: string, value: unknown): Promise<void> {
    try {
      await httpClient.put('/settings', { key, value });
    } catch (error) {
      throw toAppError(error);
    }
  }
}
